import { useRef } from 'react';
import papers from "../images/papers.png"
import backgroundImageUrl from "../images/15.png";
import mobilebackgroundImageUrl from "../images/21.png";
import transformationImageUrl from "../images/16.png";
import healingImageUrl from "../images/17.png";
import Footer from '../components/Footer';
import { FaArrowRight } from 'react-icons/fa';
import Header from '../components/Header';
import awardImage from "../images/18.png";
import learnMoreImage from "../images/19.png";
import line from "../images/line.png";
import Testimonials from '../components/Testimonials';
import bellSound from "../audio/bell.mp3";
import EmailComponent from '../components/EmailComponent';
function Home() {
    const headerRef = useRef();
    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
    };
    const buttonStyle = "flex items-center space-x-2 text-white font-semibold py-2 rounded-md transition duration-300";

    // Common styling for the image container (to mimic the border/glow effect)
    const imageContainerBase = "aspect-video w-[15em] md:w-[30em] flex items-center justify-center p-0.5 rounded-lg overflow-hidden";

    // Specific image container styles 
    const audioRef = useRef(null);
    const playSound = () => {
        audioRef.current.currentTime = 0; // restart sound if clicked again
        audioRef.current.play();
        window.open("https://app.acuityscheduling.com/schedule.php?owner=37874169", '_blank');
    };
    return (
        <div className="mb-[120px] md:mb-0">
            <Header pageName="Home" />
            <div className="min-h-screen pb-10 h-full background-with-image-blue text-white relative hidden md:block"
            >
                {/* <div className="">
                    <img
                        src={backgroundImageUrl}
                        alt="Logo"
                        className="mx-auto lg:w-[90%] xl:w-[80%]"
                    />
                </div> */}
                <div className="relative mx-auto lg:w-[90%] xl:w-[80%]">
                    <img
                        src={backgroundImageUrl}
                        alt="VIP Services"
                        className="w-full h-auto relative z-[10]"
                    />
                    <audio ref={audioRef}>
                        <source src={bellSound} />
                    </audio>
                    {/* Bell icon clickable area */}
                    <a
                        onClick={(e) => { e.preventDefault(); playSound(); }}
                        className="absolute cursor-pointer z-[20]"
                        style={{
                            top: '59%',
                            left: '0%',
                            width: '22%',
                            height: '37%',
                        }}
                        aria-label="Book your VIP Call"
                    />
                    <a
                        href="/Services"
                        className="absolute cursor-pointer  z-[20]"
                        style={{
                            top: '50%',
                            width: '18%',
                            height: '7%',
                            right: '6%'
                        }}
                        aria-label="Book your VIP Call"
                    />
                    <a
                        href="/About"
                        className="absolute cursor-pointer  z-[20]"
                        style={{
                            top: '60%',
                            width: '18%',
                            height: '7%',
                            right: '6%'
                        }}
                        aria-label="Book your VIP Call"
                    />
                    <div
                        className="absolute cursor-pointer text-center"
                        style={{
                            top: '75%',
                            width: '30%',
                            height: '7%',
                            right: '5%'
                        }}
                        aria-label="Book your VIP Call"
                    >
                        <img
                            src={line}
                            className="w-full h-[25px] relative z-[1]"
                        />
                     </div>
                    <div
                        className="absolute cursor-pointer text-center z-[20]"
                        style={{
                            top: '78%',
                            width: '30%',
                            height: '7%',
                            right: '4%'
                        }}
                        aria-label="Book your VIP Call"
                    >
                        <a href="/Contact" className='z-[12] eb-garamond text-xl 2xl:text-3xl text-center mr-auto uppercase tracking-widest'>Contact</a>
                    </div>
                </div>
                <h2 className='eb-garamond lg:text-4xl xl:text-6xl text-center mt-[-25px] w-[95%] mr-auto'>Success cost you yourself.<br />I help you get it back.</h2>
                {/* Certification badge bottom left */}
                <div className="py-10 md:mt-0 md:absolute bottom-5 right-10 flex items-center gap-2 text-sm select-none">
                    <img
                        src={awardImage}
                        alt="Logo"
                        className="mx-auto w-[15em]"
                    />
                </div>
            </div>
            <div className="h-full background-with-image-blue text-white relative block md:hidden"
            >
                <div className="relative">
                    <img
                        src={mobilebackgroundImageUrl}
                        alt="Logo"
                        className="mx-auto w-full"
                    />
                    <audio ref={audioRef}>
                        <source src={bellSound} />
                    </audio>
                    {/* Bell icon clickable area */}
                    <a
                        onClick={(e) => { e.preventDefault(); playSound(); }}
                        className="absolute cursor-pointer"
                        style={{
                            top: '73%',
                            left: '1%',
                            width: '44%',
                            height: '28%',
                        }}
                        aria-label="Book your VIP Call"
                    />
                </div>
                <h2 className='eb-garamond py-3 text-4xl text-center mr-auto'>Success cost you yourself.<br />I help you get it back.</h2>
                {/* Certification badge bottom left */}
                <div className="py-5 px-4 select-none">
                    <img
                        src={awardImage}
                        alt="Logo"
                        className="ml-auto w-[10em]"
                    />
                </div>
            </div>
            <div className="background-with-image">
                <div className="container mx-auto">
                    <section className="flex flex-col md:flex-row items-center justify-end px-8 py-16 text-white">
                        <div className="text-center md:text-left">
                            <h2 className="eb-garamond text-3xl md:text-5xl font-serif mb-8 leading-relaxed max-w-prose">
                                “Success isn’t the problem.<span className="font-bold"> Disconnection</span> is”
                            </h2>
                            <p className="poppins mb-6 text-lg md:text-lg">
                                I work with high achievers who look put together from the outside but feel disconnected,
                                exhausted or quietly angry on the inside. The ones who hit every milestone yet still wake up
                                wondering why nothing feels like enough.
                            </p>
                            <p className="poppins mb-6 text-lg md:text-lg font-normal">
                                You built a life most people dream about. The title, the money, the momentum.
                                But somewhere between the accolades and late nights, something went silent inside you.
                                The fire didn’t die, it just turned inward.
                            </p>
                        </div>
                    </section>
                </div>
            </div>
            <div className="bg-[#ecebe6]">
                <div className="container mx-auto py-10 md:py-16 px-8 ">
                    <h2 className="text-[#f15d16] eb-garamond font-semibold text-4xl md:text-5xl font-serif mb-2 md:mb-0 text-center uppercase">
                        This isn’t just feel <br className='block md:hidden' />good <span className='text-[#80a2a5]'>coaching.</span>
                    </h2>
                    <p className="poppins mb-6 text-lg md:text-2xl text-black text-center pt-2 pb-6">
                        This is identity reconstruction for men and women <br className='hidden md:block' />
                        who are tired of pretending they’re fine.
                    </p>
                    <section className="flex flex-col md:flex-row items-center justify-end text-black">
                        <div className="md:w-2/3 md:pr-12">
                            <p className="poppins mb-6 text-lg md:text-lg">
                                <span className="font-semibold">TRUE IDENTITY - </span>
                                Get clear on who you are now, not<br className='hidden md:block' />
                                who you perform to be, and stay clear under <br className='hidden md:block' />
                                pressure instead of sliding back into old patterns.
                            </p>
                            <p className="poppins mb-6 text-lg md:text-lg">
                                <span className="font-semibold">ALIGNMENT - </span>
                                Make decisions from your values, with <br className='hidden md:block' />
                                boundaries and commitments your nervous system <br className='hidden md:block' />
                                can actually live with, even when it’s hard.

                            </p>
                            <p className="poppins mb-6 text-lg md:text-lg">
                                <span className="font-semibold">IMPACT - </span>
                                Calm, confident, promotion-ready impact so <br className='hidden md:block' />
                                you can speak in your own voice, feel proud again, <br className='hidden md:block' />
                                and stop burning out your body or your relationships.

                            </p>
                        </div>
                        <div className="w-full md:w-1/3 flex flex-col gap-8 md:gap-12 mt-8 md:mt-0 mx-auto">
                            <a href='/Services' className="text-center cursor-pointer rounded-full border-transparent hover:border-white border-4 poppins hover:bg-transparent hover:text-[#f15d16] bg-[#80a2a5] text-white uppercase font-semibold text-md tracking-widest py-3 hover:opacity-90 transition delay-50 duration-300 ease-in-out">
                                VIP SERVICES
                            </a>
                            <a href='/About' className="text-center cursor-pointer rounded-full border-transparent hover:border-white border-4 poppins hover:bg-transparent hover:text-[#f15d16] bg-[#80a2a5] text-white uppercase font-semibold text-md tracking-widest py-3 hover:opacity-90 transition delay-50 duration-300 ease-in-out">
                                ABOUT IRAM
                            </a>
                            <a href='/Contact' className="text-center cursor-pointer rounded-full border-transparent hover:border-white border-4 poppins hover:bg-transparent hover:text-[#f15d16] bg-[#80a2a5] text-white uppercase font-semibold text-md tracking-widest py-3 hover:opacity-90 transition delay-50 duration-300 ease-in-out">
                                CONTACT US
                            </a>
                        </div>
                    </section>
                    <h2 className='text-[#f15d16] font-semibold eb-garamond text-4xl md:text-5xl mx-auto text-center pt-12 uppercase'><span className='text-[#80a2a5]'>Calm</span> is <br className='block md:hidden'/>your new <br className='block md:hidden'/>business plan.</h2>
                </div>
            </div>
            {/* <div className="flex flex-col items-center py-10 md:py-16 px-4 bg-[#edebe6]">
                <div className='container mx-auto'>
                    <div className="poppins bg-[#80a2a5] w-[80%] md:w-[20em] mx-auto text-white text-lg tracking-widest font-medium py-4 text-center px-6 rounded-full uppercase mb-16 shadow-md">
                        VIP SERVICES
                    </div>
                    <div className="flex flex-col md:flex-row items-center md:space-x-8 mb-8 w-full">
                        <p className="text-6xl font-light italic text-[#80a2a5] mr-4 eb-garamond md:mb-2 hidden md:block">1.</p>
                        <img
                            src={transformationImageUrl}
                            alt="Logo"
                            className="mx-auto w-[100%] md:w-[30em]"
                        />
                        <div className="mt-4 md:mt-0 flex-grow text-stone-700">
                            <h2 className="eb-garamond text-3xl md:text-4xl font-normal tracking-wide mb-2 text-stone-800">
                                TRANSFORMATIONAL COACHING
                            </h2>
                            <blockquote className="poppins italic text-2xl md:text-3xl text-stone-600 mb-2">
                                “See exactly what it looks like in your<br className='hidden md:block' /> real life”
                            </blockquote>

                            <button className={buttonStyle}>
                                <img
                                    src={learnMoreImage}
                                    alt="Logo"
                                    className="mx-auto w-[12em]"
                                />
                            </button>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row items-center md:space-x-8 w-full">
                        <p className="text-6xl font-light text-[#f15d16] mr-4 md:mb-2 eb-garamond italic hidden md:block">2.</p>
                        <img
                            src={healingImageUrl}
                            alt="Logo"
                            className="mx-auto w-full md:w-[30em]"
                        />
                        <div className="mt-4 md:mt-0 flex-grow text-stone-700">
                            <h2 className="eb-garamond text-3xl md:text-4xl font-normal tracking-wide mb-2 text-stone-800">
                                ENERGY HEALING
                            </h2>
                            <p className="dreamingOutloudRegular text-2xl md:text-3xl italic text-[#f15d16] mb-2">
                                In collaboration with energy healer Dipti Bley.
                            </p>
                            <blockquote className="poppins italic text-2xl md:text-3xl text-stone-600  mb-2">
                                “Feel lighter, clearer, and actually like yourself again”
                            </blockquote>

                            <button className={buttonStyle}>
                                <img
                                    src={learnMoreImage}
                                    alt="Logo"
                                    className="mx-auto w-[12em]"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}
            <Testimonials />
            <EmailComponent isBlue={true} />
            <Footer />
        </div>
    );
}
export default Home;